import { render } from "./ArticlesSearch.vue?vue&type=template&id=44512cef&scoped=true"
import script from "./ArticlesSearch.vue?vue&type=script&lang=js"
export * from "./ArticlesSearch.vue?vue&type=script&lang=js"

import "./ArticlesSearch.vue?vue&type=style&index=0&id=44512cef&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44512cef"]])

export default __exports__